import React, { useState } from "react";

import Button from "@common/components/Button/Button";
import Input from "@common/components/Input/Input";
import { ModalProps } from "@common/components/Modal/Modal";
import { ModalHeaderProps } from "@common/components/Modal/ModalHeader/ModalHeader";

import * as Styled from "./ModalBody.styles";

interface Props {
  appName?: string;
  deleteApp: () => void;
  loading: boolean;
  Modal: React.ForwardRefExoticComponent<ModalProps & ModalHeaderProps & React.RefAttributes<unknown>>;
  internalProps?: ModalProps;
}

export default function DeleteAppModalBody({ appName, deleteApp, loading, Modal, internalProps }: Props) {
  const [appNameInput, setAppNameInput] = useState<string>("");

  const isButtonDisabled = appNameInput !== appName;

  const handleDeleteWorkspace = (e?: React.MouseEvent<Element, MouseEvent>) => {
    e?.preventDefault();
    deleteApp();
    setAppNameInput("");
  };

  return (
    <Modal
      {...internalProps}
      heading={`Deleting ${appName}`}
      buttonElement={
        <Button
          type="button"
          size="small"
          color="red"
          disabled={isButtonDisabled || loading}
          tooltip={{
            position: "top",
            text: "Please enter correct app name to enable deleting",
            disabled: !isButtonDisabled || loading,
          }}
          loadingText={loading && "Deleting..."}
          onClick={(e) => handleDeleteWorkspace(e)}
        >
          {"Delete this app"}
        </Button>
      }
    >
      <Styled.Subtitle>{"This action cannot be undone. To proceed, type the app name to confirm."}</Styled.Subtitle>

      <Styled.Form onSubmit={(event) => event.preventDefault()}>
        <Input
          type="text"
          label="App name"
          value={appNameInput}
          onChange={(e: React.FormEvent<HTMLInputElement>) => setAppNameInput(e.currentTarget.value)}
          autoFocus
        />
      </Styled.Form>
    </Modal>
  );
}
